import { ElementType } from 'react';
import { PaymentPlanInvoiceStatus } from '@frontend/api-payment-plans';
import { Chip, ChipVariants } from '@frontend/design-system';
import { prettify } from '../../../utils/date-helpers';

type PaymentPlanInvoiceStatusChipProps = {
  paymentPlanInvoiceStatus?: PaymentPlanInvoiceStatus;
  statusReason?: string;
  as?: ElementType;
};

const mapStatus = (status: PaymentPlanInvoiceStatus): ChipVariants => {
  switch (status) {
    case PaymentPlanInvoiceStatus.Scheduled:
      return 'primary';
    case PaymentPlanInvoiceStatus.Paid:
      return 'success';
    case PaymentPlanInvoiceStatus.Partial:
    case PaymentPlanInvoiceStatus.Paused:
      return 'warn';
    case PaymentPlanInvoiceStatus.Unpaid:
      return 'critical';
    case PaymentPlanInvoiceStatus.Refunded:
      return 'disabled';
    default:
      return 'disabled';
  }
};

export const PaymentPlanInvoiceStatusChip = ({
  paymentPlanInvoiceStatus,
  statusReason,
  as,
  ...rest
}: PaymentPlanInvoiceStatusChipProps) => {
  if (!(paymentPlanInvoiceStatus && Object.values(PaymentPlanInvoiceStatus).includes(paymentPlanInvoiceStatus)))
    return null;
  return (
    <>
      <Chip variant={mapStatus(paymentPlanInvoiceStatus)} {...rest}>
        {prettify(paymentPlanInvoiceStatus, { split: '_' })}
      </Chip>
    </>
  );
};
